<!--
 * @Author: chenyingxuan chenyingxuan@abc.com
 * @Date: 2023-11-15 10:29:55
 * @LastEditors: chenyingxuan chenyingxuan@abc.com
 * @LastEditTime: 2024-01-05 11:09:52
 * @FilePath: /platform/src/components/helpList/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <el-popover popper-class="header-popper1" :visible-arrow="false" width="120px" trigger="click">
    <el-button slot="reference" type="text" style="margin: 0 30px" class="helpSet">
      <i class="iconfont icon-back-bangzhu" />
      <p>帮助</p>
    </el-button>
    <template>
      <ul class="i18n-select-ul">
        <li v-for="(item, index) in helpList" :key="index" @click="handleSetLanguage(item.url)">
          {{ item.name }}
        </li>
      </ul>
    </template>
  </el-popover>
</template>

<script>
export default {
  name: 'help-list',
  data() {
    return {
      helpList: [
        {
          name: '常见问题',
          url: 'https://iezu.yuque.com/books/share/b4b05941-a047-4200-92a9-2df8cbbe11d3'
        },
        {
          name: '操作视频',
          url: 'https://iezu.yuque.com/books/share/2f20d07e-a32e-4db5-8bed-560ed6fd9264'
        },

        {
          name: '操作手册',
          url: 'https://iezu.yuque.com/books/share/b9c749d8-1980-4051-abb7-2132d1264992'
        },

        {
          name: '软件版本',
          url: 'https://iezu.yuque.com/books/share/cd9af3c4-f9e6-4f62-a295-0c277f6dc498'
        },

        {
          name: '易筑课堂',
          url: 'https://iezu.yuque.com/mc084b/lsf8c7'
        }
      ]
    }
  },
  methods: {
    handleSetLanguage(url) {
      if (url) {
        window.open(url)
      }
    }
  }
}
</script>

<style scoped>
.el-link {
  margin-right: 20px;
  font-size: 13px;
}
.i18n-select-ul {
  list-style: none;
  padding: 4px 0;
  margin: 0;
}
.i18n-select-ul > li {
  width: 120px;
  height: 32px;
  background: #fff;
  cursor: pointer;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  color: #393b3e;
  line-height: 32px;
}
.i18n-select-ul > li:hover {
  background: #e8f0fa;
}
.helpSet.el-button--text,
.helpSet.el-button--text:hover,
.helpSet.el-button--text:focus {
  color: unset;
}
.helpSet.el-button--text i {
  color: #8c8c90 !important;
  font-size: 16px;
}
.helpSet.el-button--text p {
  color: #333 !important;
  font-size: 10px;
  line-height: 14px;
  margin: 0;
}
</style>
<style>
.header-popper1 {
  min-width: unset !important;
  padding: 0 !important;
}
</style>
